export default __webpack_public_path__ + "static/media/bg_circle.734ed106.png";